<h3>Qu'est-ce que le Carbone-Score ?</h3>
<p>
  Le Carbone-Score est un logo qui vous informe sur l'empreinte carbone d'une recette. Il est basé sur une échelle à 5 niveaux, de l'impact le plus faible A
  (<=80g CO2/100g), à l'impact le plus élevé E (>530g CO2/100g).
</p>

<div class="carbonscore">
  <ion-icon class="carbonscore-picto" src="/assets/svg/dish/carbon-score/carbon-score-A.svg"></ion-icon>
  <ion-icon class="carbonscore-picto" src="/assets/svg/dish/carbon-score/carbon-score-B.svg"></ion-icon>
  <ion-icon class="carbonscore-picto" src="/assets/svg/dish/carbon-score/carbon-score-C.svg"></ion-icon>
  <ion-icon class="carbonscore-picto" src="/assets/svg/dish/carbon-score/carbon-score-D.svg"></ion-icon>
  <ion-icon class="carbonscore-picto" src="/assets/svg/dish/carbon-score/carbon-score-E.svg"></ion-icon>
</div>

<h3>Comment le Carbone-Score est-il calculé ?</h3>
<p>
  Des experts indépendants en stratégie carbone ont attribué un facteur d'émission robuste à chaque ingrédient de nos recettes en s'appuyant sur les bases de
  données scientifiques référentes en France. Ces facteurs d'émission sont ensuite affinés selon les critères de saisonnalité, mode de production (Bio,
  labels..), de conservation et de distance moyenne des approvisionnements. <br />
  Ils sont ensuite agrégés au prorata de la recette afin d'obtenir l'impact carbone de la recette, exprimé pour 100g.
</p>

<h3>Quelle est la finalité du Carbone-Score ?</h3>
<ul>
  <li>- Offrir une réelle transparence sur l'empreinte carbone de nos recettes</li>
  <li>- Sensibiliser chacun à une alimentation durable</li>
</ul>
<h3>Et concrètement, ça change quoi pour vous ?</h3>
<p>Le Carbone-Score permet de comparer facilement l'empreinte carbone de nos recettes afin de faire des choix éclairés en matière d'alimentation durable.</p>
<footer>
  <p>LE CHOIX DE BIEN MANGER AU QUOTIDIEN TOUT EN REDUISANT SON IMPACT ENVIRONNEMENTAL !</p>
</footer>
